import type { S3File } from './File';

export const DocumentTypename = 'Document';

export enum DocumentType {
  APP = 'APP',
  BOOK = 'BOOK',
  BOOKMARK = 'BOOKMARK',
  EML = 'EML',
  EXCEL = 'EXCEL',
  FOLDER = 'FOLDER',
  GAME = 'GAME',
  INFO = 'INFO',
  MUSIC = 'MUSIC',
  NOTE = 'NOTE',
  PDF = 'PDF',
  PICTURE = 'PICTURE',
  POWERPOINT = 'POWERPOINT',
  UNDEFINED = 'UNDEFINED',
  UNKNOWN = 'UNKNOWN',
  VIDEO = 'VIDEO',
  WORD = 'WORD',
}

export interface SharedDocument {
  id: string;
  blob: S3File;
  key: string;
  creator: string;
  name: string;
  type: DocumentType;
}
